module.exports = __webpack_public_path__ + "img/house.5058677a.svg";